import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
import { E_ChargeMode, E_PackageTag, E_PrivliegeLimitationWay } from '../apis/service/PackageApi.types';
import { boPaginationLoadAll } from '../@core/utils/pagination';
import { E_ResourceStatus } from '../apis/service/CompanyPermissionApi.type';
export function hasEnterpriseRestriction(enterprise_restriction) {
    return _.isNil(enterprise_restriction) ? true : enterprise_restriction;
}
export const PrivliegeLimitationWays = [
    E_PrivliegeLimitationWay.SSO,
    E_PrivliegeLimitationWay.IP_Range,
    E_PrivliegeLimitationWay.Domains
];
let CompanyOrderService = class CompanyOrderService {
    constructor(companyOrderApi, packageApi, miscApi, i18n, companyPermissionApi) {
        this.companyOrderApi = companyOrderApi;
        this.packageApi = packageApi;
        this.miscApi = miscApi;
        this.i18n = i18n;
        this.companyPermissionApi = companyPermissionApi;
        /**
         * 查询订单列表
         */
        this.getOrders = this.companyOrderApi.getOrders;
        this.getBehaviorOrders = this.companyOrderApi.getBehaviorOrders;
        /**
         * 添加订单
         */
        this.postOrderAdd = this.companyOrderApi.postOrderAdd;
        /**
         * 获取订单详情
         */
        this.getOrderDetail = this.companyOrderApi.getOrderDetail;
        /**
         * 编辑订单
         */
        this.putOrderEdit = this.companyOrderApi.putOrderEdit;
        /**
         * 检查订单
         */
        this.postOrderCheck = this.companyOrderApi.postOrderCheck;
        /**
         * 确认订单号是否存在
         */
        this.getOrderContractExisted = this.companyOrderApi.getOrderContractExisted;
        /**
         * 删除Privilege / Anonymous
         */
        this.patchCompanyPrivilegeContractDelete = this.companyOrderApi.patchCompanyPrivilegeContractDelete;
        /**
         * 删除整体容量
         */
        this.patchCompanyCapacityContractAllDelete = this.companyOrderApi.patchCompanyCapacityContractAllDelete;
        /**
         * 预检查编辑订单
         */
        this.postOrderEditCheck = this.companyOrderApi.postOrderEditCheck;
        this.getResourceCustomizedList = this.companyPermissionApi.getResourceCustomizedList;
        this.getPackageByChargeMode = this.packageApi.getPackageByChargeMode;
        this.postOrderVolumeBatch = this.miscApi.postOrderVolumeBatch;
    }
    get IsCN() {
        return this.i18n.locale === 'cn';
    }
    getAllActiveCapacityList() {
        const task = (params) => this.companyPermissionApi.getCapacityList({
            status: E_ResourceStatus.ENABLED,
            ...params,
        });
        return boPaginationLoadAll(task);
    }
    showPackage(pkg) {
        const name = this.IsCN ? pkg.package_name : pkg.en_name;
        const version = pkg.package_version;
        return version ? `${name}(${version})` : name;
    }
    hasCustomCapacity(contractCapacityConfigs) {
        return !!(contractCapacityConfigs && contractCapacityConfigs.length > 0);
    }
    showCapacity(capacity) {
        const name = this.IsCN ? capacity.name_cn : capacity.name_us;
        if (!capacity.cyclical_type) {
            return name;
        }
        const cyclical = this.i18n.t('enum.E_ResourceCyclical.' + capacity.cyclical_type);
        return `${name}/${cyclical}`;
    }
    switchOrderStatus(params) {
        const { order_id, status, } = params;
        if (status) {
            return this.companyOrderApi.patchOrderEnable(order_id);
        }
        else {
            return this.companyOrderApi.patchOrderDisable(order_id);
        }
    }
    buildPrivliegeLimitationWays(companyInfo) {
        return [
            ...PrivliegeLimitationWays
        ];
    }
    getSafeChargeModes(filterFn) {
        return this.packageApi.getChargeModes().then(chageModeCodes => {
            return _.flatMap(chageModeCodes, chageModeCode => {
                const chageMode = chageModeCode.system_code;
                if (filterFn(chageMode) && chageMode !== E_ChargeMode.HISTORICAL) {
                    return [chageMode];
                }
                else {
                    return [];
                }
            });
        });
    }
    isAnonymous(privilegeContract) {
        return _.findIndex(privilegeContract.package_vo_list, pkg => pkg.package_tag === E_PackageTag.ANONYMOUS) >= 0;
    }
    isOpenAPI(privilegeContract) {
        return _.isObject(privilegeContract.openapi_vo);
    }
};
CompanyOrderService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyOrderApi)),
    __param(1, inject(Symbols.PackageApi)),
    __param(2, inject(Symbols.MiscApi)),
    __param(3, inject(Symbols.I18n)),
    __param(4, inject(Symbols.CompanyPermissionApi)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object])
], CompanyOrderService);
export { CompanyOrderService };
